import styled from 'styled-components';
import { StyledSectionContainer } from '../../globalStyled';
import { sectionTitle } from '../../theme/typography';

export const StyledChartContainer = styled(StyledSectionContainer)`
  overflow: hidden;

  h3 {
    ${sectionTitle};
    width: 100%;
    font-size: 18px;
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  }
  .recharts-cartesian-axis-tick {
    font-size: 10px;
  }
  .recharts-cartesian-axis-tick-value {
    fill: ${({ theme }) => theme.textFaint};
  }
`;

export const StyledTooltip = styled.div`
  padding: 8px 10px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
`;

export const StyledDate = styled.p`
  font-size: 10px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
  margin-bottom: 6px;
`;
export const StyledVal = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text};
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
`;
